module.exports = __webpack_public_path__ + "img/32.e2a7be0f.png";